<template>    
  <div class="w-full flex flex-col">
    <div class="flex flex-row justify-between items-center gap-2">
      <div class="flex flex-row items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <g clip-path="url(#clip0_848_24479)">
            <path
              d="M13.3677 15.6848L8.43516 10.7711C8.08898 10.921 7.71262 11.0406 7.30607 11.1299C6.89936 11.2192 6.48725 11.2639 6.06974 11.2639C4.51832 11.2639 3.18981 10.7152 2.0842 9.61773C0.978424 8.52014 0.425537 7.19563 0.425537 5.64421C0.425537 5.10793 0.485987 4.59537 0.606888 4.10653C0.727625 3.61769 0.915111 3.16435 1.16935 2.74652L4.64642 6.20495L6.7041 4.14727L3.26482 0.689084C3.68249 0.46757 4.12789 0.297344 4.60102 0.178407C5.07415 0.0594692 5.56373 0 6.06974 0C7.63769 0 8.97038 0.556896 10.0678 1.67069C11.1652 2.78464 11.714 4.11888 11.714 5.67341C11.714 6.08437 11.6708 6.46033 11.5846 6.80127C11.4984 7.14238 11.3773 7.47972 11.2212 7.8133L16.2332 12.8195C16.4371 13.0312 16.539 13.287 16.539 13.5868C16.539 13.8869 16.4377 14.1382 16.2352 14.3407L14.8455 15.7059C14.6417 15.9082 14.3954 16.0063 14.1066 16.0001C13.8178 15.9937 13.5715 15.8886 13.3677 15.6848ZM14.1172 14.6298L15.2119 13.5593L9.68105 8.07735C9.98928 7.67211 10.1925 7.23636 10.2906 6.7701C10.3888 6.30384 10.4379 5.93672 10.4379 5.66875C10.4379 4.46825 9.97537 3.40738 9.05038 2.48615C8.12538 1.56492 6.98582 1.16156 5.6317 1.27608L7.95565 3.57524C8.11663 3.73933 8.19712 3.93074 8.19712 4.14947C8.19712 4.36821 8.11426 4.55987 7.94853 4.72445L5.20103 7.45109C5.03514 7.61567 4.8488 7.69796 4.642 7.69796C4.43521 7.69796 4.25419 7.61747 4.09893 7.45649L1.70162 5.05893C1.55683 6.51497 1.94759 7.7005 2.8739 8.61551C3.8002 9.53037 4.86548 9.98779 6.06974 9.98779C6.35212 9.98779 6.74083 9.93209 7.23589 9.82067C7.73078 9.70943 8.1972 9.48513 8.63516 9.14779L14.1172 14.6298Z"
              fill="#696969" />
          </g>
          <defs>
            <clipPath id="clip0_848_24479">
              <rect width="16" height="16" fill="white" transform="translate(0.482422)" />
            </clipPath>
          </defs>
        </svg>
        <h4 class="nxp-review-title">Habilidades</h4>
      </div>

      <button class="nxp-review-title-action" type="button" @click="$router.push({ name: 'edit-skills' })">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path
            d="M4.54 15.4993H5.46625L13.6633 7.30227L12.7371 6.37602L4.54 14.5731V15.4993ZM3.45667 16.5827V14.1164L13.8237 3.73331C13.9358 3.61886 14.0565 3.5374 14.1856 3.48893C14.3148 3.44032 14.4501 3.41602 14.5917 3.41602C14.7333 3.41602 14.8685 3.43872 14.9973 3.48414C15.1262 3.52956 15.251 3.60997 15.3717 3.72539L16.306 4.65164C16.4215 4.77234 16.5032 4.89734 16.5512 5.02664C16.5993 5.15595 16.6233 5.28907 16.6233 5.42602C16.6233 5.57199 16.5981 5.71129 16.5475 5.84393C16.4968 5.97657 16.4163 6.09782 16.306 6.20768L5.92292 16.5827H3.45667ZM13.1921 6.84727L12.7371 6.37602L13.6633 7.30227L13.1921 6.84727Z"
            fill="#4F4F4F" />
        </svg>
        Editar
      </button>
    </div>
    <hr class="custom-hr my-2 mb-4" />

    <div v-if="show()" class="nxp-skills-grid px-6">
      <div
        class="nxp-skills-grid-item py-4"
        v-for="(item, index) in skills"
        :key="`skill-${index}`"
      >
        <p class="nxp-review-experiencies-title">
          {{ item.skill }}
        </p>
      </div>
    </div>

    <div v-else class="w-full flex flex-col items-center justify-center space-y-4 py-8">
      <p class="nxp-review-no-data-text">
        Suas habilidades ainda não foram adicionadas, <br />inclua para mostrar suas competências
      </p>
      <button class="nxp-review-no-data-btn" type="button" @click="$router.push({ name: 'edit-skills' })">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <path
            d="M8.22616 8.75597H2.58252V7.24325H8.22616V1.59961H9.73888V7.24325H15.3825V8.75597H9.73888V14.3996H8.22616V8.75597Z"
            fill="#4F4F4F" />
        </svg>
        Adicionar Habilidades
      </button>
    </div>
  </div>
</template>

<script>
import { get } from "lodash";
import { mapState } from 'vuex';

import EmptyDetailCard from '@/components/dashboard/profile-detail/EmptyDetailCard';

export default {
    computed: {
        ...mapState('skill', ['skills']),
        ...mapState('company', ['company']),

        color() {
            return get(this.$store, 'state.company.base_hexcolor', '#1551b1');
        },
    },
    methods: {
        show() {
            return this.skills.length > 0
        },
    },

    components: {
        EmptyDetailCard
    },
}
</script>

<style lang="scss">
@import '@/assets/scss/talent/components/skillsdetailcard.scss';

hr {
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    border: none;
}
</style>